"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _colors = require("HubStyleTokens/colors");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _OverallDistribution = _interopRequireDefault(require("./OverallDistribution"));

var _QualityDistribution = _interopRequireDefault(require("./QualityDistribution"));

var _ReviewAxes = require("../../constants/reviews/ReviewAxes");

var _ReviewStats = _interopRequireDefault(require("../../records/ReviewStats"));

var _Rating = _interopRequireDefault(require("./Rating"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 56px;\n  margin-bottom: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var RatingNumberDisplay = (0, _styledComponents.default)(_H.default).withConfig({
  displayName: "ReviewsListStats__RatingNumberDisplay",
  componentId: "sc-1y8ie6h-0"
})(_templateObject());

var ColumnBlock = _styledComponents.default.div.withConfig({
  displayName: "ReviewsListStats__ColumnBlock",
  componentId: "sc-1y8ie6h-1"
})(_templateObject2(), _colors.GREAT_WHITE);

var RowBlock = _styledComponents.default.div.withConfig({
  displayName: "ReviewsListStats__RowBlock",
  componentId: "sc-1y8ie6h-2"
})(_templateObject3());

var textPath = 'ecosystemMarketplaceCore.reviews.stats';

var ReviewsListStats = function ReviewsListStats(_ref) {
  var allReviewsHref = _ref.allReviewsHref,
      className = _ref.className,
      inline = _ref.inline,
      onFilterChange = _ref.onFilterChange,
      reviewStats = _ref.reviewStats;
  var overallRatingAvg = reviewStats.getAxisAverage(_ReviewAxes.ReviewAxes.OVERALL);
  var overallRatingAvgDisplay = overallRatingAvg.toFixed(1);
  var flexDirection = inline ? 'row' : 'column';
  var flexWidth = inline ? '100%' : 'auto';
  var Block = inline ? RowBlock : ColumnBlock;
  return _react.default.createElement(_UIFlex.default, {
    direction: flexDirection,
    justify: "between",
    style: {
      width: flexWidth
    },
    className: className
  }, _react.default.createElement(Block, {
    style: {
      paddingTop: '0'
    }
  }, _react.default.createElement(RatingNumberDisplay, null, overallRatingAvgDisplay), _react.default.createElement(_Rating.default, {
    rating: overallRatingAvg,
    direction: "column",
    label: _react.default.createElement(_FormattedMessage.default, {
      message: textPath + ".reviewCount",
      options: {
        count: reviewStats.get('count')
      }
    }),
    labelSize: "medium"
  }), allReviewsHref && _react.default.createElement("div", {
    className: "m-top-2"
  }, _react.default.createElement(_UILink.default, {
    href: allReviewsHref
  }, _react.default.createElement(_FormattedMessage.default, {
    message: textPath + ".seeAllReviews"
  })))), _react.default.createElement(Block, null, _react.default.createElement(_OverallDistribution.default, {
    onFilterChange: onFilterChange,
    reviewStats: reviewStats
  })), _react.default.createElement(Block, null, _react.default.createElement(_QualityDistribution.default, {
    heading: _react.default.createElement(_FormattedMessage.default, {
      message: "ecosystemMarketplaceCore.reviews.qualityDistribution.heading"
    }),
    labelSize: "md",
    qualityRatings: reviewStats.getQualityRatings(),
    showLabelTooltips: true
  })));
};

ReviewsListStats.propTypes = {
  allReviewsHref: _propTypes.default.string,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool.isRequired,
  onFilterChange: _propTypes.default.func.isRequired,
  reviewStats: _propTypes.default.instanceOf(_ReviewStats.default).isRequired
};
ReviewsListStats.defaultProps = {
  inline: false
};
var _default = ReviewsListStats;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/reviews/ReviewsListStats.js
// module id = 415
// module chunks = 209 210 211 212